export default defineNuxtRouteMiddleware((to) => {
  const { hash, matched, path, query } = to

  if (path !== '/' && !path.endsWith('/') && matched.length) {
    return navigateTo({ hash, path: `${path}/`, query }, { redirectCode: 301 })
  }
})
